/* pogi-help — search/filter + category rail for the Help center section.
   Filters <details data-help-qa> by question+answer text, hides empty
   category groups, shows a match count and the empty state, and toggles
   the .is-searching layout (rail + quick actions hidden). */

class PogiHelp extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-help-search]');
    this.clearBtn = this.querySelector('[data-help-clear]');
    this.countEl = this.querySelector('[data-help-count]');
    this.emptyEl = this.querySelector('[data-help-empty]');
    this.groups = Array.from(this.querySelectorAll('[data-help-group]'));
    this.items = Array.from(this.querySelectorAll('[data-help-qa]'));
    this.railLinks = Array.from(this.querySelectorAll('[data-help-cat]'));

    // cache searchable text once
    this.items.forEach((d) => {
      d.dataset.helpText = d.textContent.toLowerCase().replace(/\s+/g, ' ');
    });

    this.input?.addEventListener('input', () => this.filter());
    this.clearBtn?.addEventListener('click', () => {
      this.input.value = '';
      this.input.focus();
      this.filter();
    });

    // rail active state
    this.railLinks.forEach((a) => {
      a.addEventListener('click', () => {
        this.railLinks.forEach((x) => x.classList.toggle('is-active', x === a));
      });
    });
  }

  filter() {
    const q = (this.input?.value || '').trim().toLowerCase();
    const searching = q.length > 0;
    this.classList.toggle('is-searching', searching);
    if (this.clearBtn) this.clearBtn.hidden = !searching;

    let total = 0;
    this.groups.forEach((g) => {
      let groupHits = 0;
      g.querySelectorAll('[data-help-qa]').forEach((d) => {
        const hit = !searching || d.dataset.helpText.includes(q);
        d.hidden = !hit;
        if (hit) groupHits += 1;
      });
      g.hidden = searching && groupHits === 0;
      total += groupHits;
    });

    if (this.countEl) {
      this.countEl.hidden = !searching;
      if (searching) {
        const n = total;
        this.countEl.textContent = `${n} ${n === 1 ? 'answer' : 'answers'} for "${this.input.value.trim()}"`;
      }
    }
    if (this.emptyEl) this.emptyEl.hidden = !(searching && total === 0);
  }
}

if (!customElements.get('pogi-help')) customElements.define('pogi-help', PogiHelp);
